import React from 'react';

export interface LzPCanvasHeading {
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export default function LzXCanvasHeading(props: LzPCanvasHeading) {
    const style: React.CSSProperties = props.style || {};
    if (!style.color) {
        style.color = '#4a4a4a';
    }
    if (!style.fontWeight) {
        style.fontWeight = 400;
    }
    if (!style.textTransform) {
        style.textTransform = 'uppercase';
    }

    return (
        <h3
            className={props.className}
            style={style}
        >{props.children}</h3>
    );
}
